<template>
  <v-expansion-panel @click="toggleLayer">
    <v-expansion-panel-header>
      <template v-slot:default="{ open }">
        <v-checkbox
          :value="open"
          :input-value="open"
          label="Satellite Derived Bathymetry"
          class="menu-checkbox"
        ></v-checkbox>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-select label="Datetime" :items="currents_dates" v-model="active_date">
        <v-icon
          slot="prepend"
          :disabled="disableNextButton"
          @click="nextDate(active_date, currents_dates)"
          >mdi-menu-left
        </v-icon>
        <v-icon
          slot="append-outer"
          :disabled="disablePreviousButton"
          @click="previousDate(active_date, currents_dates)"
          >mdi-menu-right
        </v-icon>
      </v-select>
      <p>
        Satellite-Derived Bathymetry (SDB) describes the method of generating
        dense spatial information on shallow water bathymetry. It allows to
        access current and past seafloor topography without mobilisation of
        equipment or staff. The data shown here are contour lines derived out of
        a dense SDB grid for two time steps. The data are provided for
        demonstration purposes only.
      </p>

      <v-container class="ma-0 pa-0">
        <v-row>
          <v-col class="pb-0"><b>Legend</b></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col align="left">-10 m</v-col>
          <v-col align="right">0 m</v-col>
        </v-row>
      </v-container>
      <div class="legend legend-results" style="width: 100%; height: 30px" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import MapServices from "@/services/mapbox.service";

export default {
  name: "bathymetryLayer",
  data: () => ({
    layer_active: false,
    active_date: "2020-09-17",
    currents_dates: ["2020-09-17", "2015-09-19"]
  }),
  computed: {
    disableNextButton() {
      return (
        this.currents_dates.indexOf(this.active_date) ===
        this.currents_dates.length - 1
      );
    },
    disablePreviousButton() {
      return this.currents_dates.indexOf(this.active_date) === 0;
    },
    layerName() {
      return `bathy_${this.active_date}_layer`;
    }
  },
  methods: {
    toggleLayer() {
      if (this.layer_active) {
        MapServices.removeLayer(this.layerName);
        this.layer_active = false;
      } else {
        MapServices.addBathy(this.active_date);
        this.layer_active = true;
      }
    },
    nextDate(selectedElement, selection) {
      const selectedPeriodIndex = selection.indexOf(selectedElement);
      if (selectedPeriodIndex < selection.length - 1) {
        this.active_date = selection[selectedPeriodIndex + 1];
      }
    },
    previousDate(selectedElement, selection) {
      const selectedPeriodIndex = selection.indexOf(selectedElement);
      if (selectedPeriodIndex > 0) {
        this.active_date = selection[selectedPeriodIndex - 1];
      }
    }
  },
  watch: {
    active_date(date_string, old_date) {
      MapServices.removeLayer(`bathy_${old_date}_layer`);
      MapServices.addBathy(date_string);
    }
  }
};
</script>

<style scoped>
.menu-checkbox {
  height: 30px;
  padding: 0;
  margin: auto 0;
}

.legend {
  background: linear-gradient(
    to right,
    #0000ff 5%,
    #3661ff 25%,
    #38acff 45%,
    #00ffff 65%,
    #aaff00 75%,
    #ffff00 80%,
    #ffaa00 85%,
    #e64c00 90%,
    #e60000 95%,
    #e80000 100%
  );
  border-width: 1px;
  border-color: black;
  border-style: solid;
}
</style>
